import { useState } from "react";
import CrudTable from "@/components/CrudTable";
import { MODULES } from "@/config/modules";
import { useLookups } from "@/hooks/useLookups";
import { fmtCurrency } from "@/lib/format";

export default function Counselling() {
  const { lists, nameMap } = useLookups();
  const [rows, setRows] = useState([]);

  const total = rows.length;
  const showed = rows.filter((r) => r.show_up === "Yes").length;
  const converted = rows.filter((r) => r.converted === "Yes").length;
  const collected = rows.reduce((s, r) => s + Number(r.admission_fee || 0), 0);
  const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

  const stages = [
    { label: "Counselling Sessions", value: total, color: "#0F172A", ratio: 100 },
    { label: "Showed Up", value: showed, color: "#C9A24B", ratio: pct(showed, total) },
    { label: "Converted", value: converted, color: "#059669", ratio: pct(converted, total) },
  ];

  const header = (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 rounded-lg bg-white border border-slate-200 p-5">
        <h3 className="font-heading font-bold text-navy mb-4">Counselling Funnel</h3>
        <div className="space-y-3">
          {stages.map((s) => (
            <div key={s.label}>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-navy font-medium">{s.label}</span>
                <span className="text-slate">{s.value} · {s.ratio}%</span>
              </div>
              <div className="h-3 rounded-full bg-slate-100 overflow-hidden">
                <div className="h-full rounded-full transition-transform duration-500" style={{ width: `${s.ratio}%`, background: s.color }} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-lg bg-navy text-white p-5 flex flex-col justify-center">
        <p className="text-xs uppercase tracking-widest text-gold font-semibold mb-1">Fees Collected</p>
        <div className="font-heading text-3xl font-extrabold">{fmtCurrency(collected)}</div>
        <p className="text-slate-300 text-sm mt-2">Flows directly into Finance — no duplicate entry.</p>
      </div>
    </div>
  );

  return (
    <div data-testid="counselling-page">
      <CrudTable resource="counselling" config={MODULES.counselling} lists={lists} nameMap={nameMap} onData={setRows} extraHeader={header} />
    </div>
  );
}
